import React, { useId } from "react";
import * as Label from "@radix-ui/react-label";
import "./SpaceFilters.scss";
import { Select } from "@/components/atoms";

interface SpaceFiltersProps {
  zones: string[];
  zoneLabels: Record<string, string>;
  selectedZone: SpaceFiltersProps["zones"][number] | null;
  sortOrder: "name-asc" | "name-desc";
  onZoneChange: (zone: SpaceFiltersProps["zones"][number] | null) => void;
  onSortChange: (order: "name-asc" | "name-desc") => void;
}

/**
 * Component for space filters (zone tabs and sorting)
 * @component
 * @param {SpaceFiltersProps} props - Component props
 * @returns {React.ReactNode} JSX element
 */
export const SpaceFilters: React.FC<SpaceFiltersProps> = ({
  zones,
  zoneLabels,
  selectedZone,
  sortOrder,
  onZoneChange,
  onSortChange,
}) => {
  const zoneSelectId = useId();
  const sortSelectId = useId();

  return (
    <div className="space-filters">
      <div className="space-filters__filter-container space-filters__filter-container--zones">
        <Label.Root htmlFor={zoneSelectId} className="space-filters__sort-label">
          Zona:
        </Label.Root>
        <Select
          id={zoneSelectId}
          options={{
            ALL: "Todas las zonas",
            ...Object.fromEntries(
              zones.sort().map((zone) => [zone, zoneLabels[zone] || zone]),
            ),
          }}
          value={selectedZone || "ALL"}
          onChange={(value) => onZoneChange(value === "ALL" ? null : value)}
        />
      </div>

      <div className="space-filters__filter-container space-filters__filter-container--sort">
        <Label.Root htmlFor={sortSelectId} className="space-filters__sort-label">
          Ordenar:
        </Label.Root>
        <Select
          id={sortSelectId}
          options={{
            "name-asc": "A - Z",
            "name-desc": "Z - A",
          }}
          value={sortOrder}
          onChange={(value) => onSortChange(value as "name-asc" | "name-desc")}
        />
      </div>
    </div>
  );
};

export default SpaceFilters;
